export default __webpack_public_path__ + "assets/icon-image-square.d96d7793.svg";